import { useState, useEffect, useRef, useCallback } from 'react';

import FullHeightDivWithStyle from './common/FullHeightDivWithStyle';
//import DebugDiv from "./common/DebugDiv";
import POSdk from './poSDK/POSdk';
import { usePOWebofficeSDKState } from '../context/poWebOfficeSDKContext';
import {
  removeTempfiles,
  useIndexedDBDispatch,
  useIndexedDBState
} from '../context/indexedDBContext';
import Header from './Header';
import styled from 'styled-components';
import {
  QS_CONSTANT,
  PRODUCT_TYPE,
  USE_REACT_ROUTER,
  selectFormatAuto,
  DOCUMENT_TYPE,
  DOC_FORMAT_CONFIG_VALUES
} from '../define/global';

import { useDispatch } from 'react-redux';
import DialogSelector from './dialog/DialogSelector';
import { useDocInfoSliceSelector } from '../store/modules/docInfo';

import Toast from './common/Toast';

import {
  setClientOS,
  setDeviceType,
  setExtensionConnectMode,
  setIsUnsupportDownload,
  setProductType,
  useAppDataSliceSelector
} from '../store/modules/appData';
import PopupAd from './popup/PopUpAd';
import PopUpAppInstall from './popup/PopUpAppInstall';

import LoadingSplash from './LoadingSplash';

import { getProductTypeFromQSObject, isDevMode, parseInfoFromUA } from '../utils/util';
import { getQSObject, getValueOfQSObject } from '../utils/qsUtils';
import MobileBottomAD from './common/mobile/MobileBottomAD';

import { FIXED_AD_ID } from './common/FixedAD';

import { useTranslation } from 'react-i18next';
import FileMenuMain from './fileMenu/FileMenuMain';

import { useChangeHouseEvenetListener } from '../utils/AdUtil';
import AppMainProcess from '../utils/AppMainProcess';
import { usePopupSliceSelector } from '../store/modules/popup';
import Confirm from './confirm/Confirm';
import { setAppLoading } from '../store/modules/appLoading';
import { useExtFontsData } from '../hooks/useExtFontHook';
import Notification from './notification/Notification';
import WhaleHandler from './extensions/WhaleHandler';
import ContextMenu from './contextMenu/ContextMenu';
import NaverWorksProcessPopup from './naverWorks/NaverWorksProcessPopup';
import { setWhiteList } from '../store/modules/whiteList';
import { getActiveLinkWhiteList } from '../extApis/activeLinkApi';

const Main = styled.main`
  flex: 1;
  width: 100%;
  position: relative;
  overflow: hidden;
`;

function AppMain({ location, match, history }) {
  const [shareID, setShareID] = useState('');
  const [su, setSU] = useState(true);
  const dispatch = useDispatch();
  const poSDKContextState = usePOWebofficeSDKState();
  const docInfoSlice = useDocInfoSliceSelector();
  const popupState = usePopupSliceSelector();
  const indexedDBState = useIndexedDBState();
  const appData = useAppDataSliceSelector();
  const indexedDBDispatch = useIndexedDBDispatch();
  const [res, setRes] = useState(undefined);
  const { i18n } = useTranslation();
  const extensionConnectMode = useRef(false);

  //Regiter EventListener
  useChangeHouseEvenetListener();

  useEffect(() => {
    if (location) selectFormatAuto(location);
    else selectFormatAuto(window.location);
  }, [location]);

  useEffect(() => {
    dispatch(setAppLoading(true));
  }, [dispatch]);

  const extFontsInfo = useExtFontsData();

  const updateWhiteList = useCallback(async () => {
    try {
      if (
        DOC_FORMAT_CONFIG_VALUES.sdk.documnetType === DOCUMENT_TYPE.HWP ||
        DOC_FORMAT_CONFIG_VALUES.sdk.documnetType === DOCUMENT_TYPE.WORD
      ) {
        let list = [];
        const resList = await getActiveLinkWhiteList();
        if (resList && resList.length > 0) {
          list = resList
            .map((url) => {
              try {
                const urlObj = new URL(url);
                return `${urlObj.host.replace('www.', '')}${urlObj.pathname}`;
              } catch (err) {
                return null;
              }
            })
            .filter((url) => url);
        }
        poSDKContextState.poInstance.handle.setActiveLinkDomainList(list);
        dispatch(setWhiteList(list));
      }
    } catch (err) {}
  }, [dispatch, poSDKContextState]);

  //const [AppMainProcess] = useAppMainProcess({ preparsedData: { isPCView, clientOS } });

  useEffect(() => {
    //get Env Config From User Agent
    const { deviceType, clientOS, isUnsupportDownload } = parseInfoFromUA();

    dispatch(setIsUnsupportDownload(isUnsupportDownload));
    dispatch(setDeviceType(deviceType));

    dispatch(setClientOS(clientOS));

    const query = getQSObject();
    dispatch(
      setExtensionConnectMode(
        getValueOfQSObject(query, QS_CONSTANT.EXTENSION_CONNECT_MODE.KEY) === 'true' || false
      )
    );

    const productType = getProductTypeFromQSObject();
    switch (productType) {
      case QS_CONSTANT.PRODUCT_TYPE.VALUES.WITH_DROPBOX:
        dispatch(setProductType(PRODUCT_TYPE.WITH_DROPBOX));
        AppMainProcess.runWithDropBox(dispatch, setRes);
        break;
      case QS_CONSTANT.PRODUCT_TYPE.VALUES.WITH_GOOGLE_DRIVE:
        dispatch(setProductType(PRODUCT_TYPE.WITH_GOOGLE_DRIVE));
        AppMainProcess.runWithGoogleDrive(dispatch, i18n, setRes);
        break;
      case QS_CONSTANT.PRODUCT_TYPE.VALUES.WITH_WHALE_SPACE:
        dispatch(setProductType(PRODUCT_TYPE.WITH_WHALE_SPACE));
        AppMainProcess.runWithWhaleSpace(
          dispatch,
          i18n,
          indexedDBState.files,
          { match, location, history },
          {
            setRes,
            setSU,
            setShareID
          }
        );
        break;
      default:
        dispatch(setProductType(PRODUCT_TYPE.STANDALONE));
        AppMainProcess.runStandAlone(dispatch, i18n, indexedDBState.files, {
          setRes,
          setSU,
          setShareID
        });
        break;
    }
  }, [dispatch, i18n]);

  // useEffect(() => {
  //   if (appData.productType === PRODUCT_TYPE.WITH_WHALE_SPACE) {
  //     updateWhiteList();
  //   }
  // }, [updateWhiteList, appData.productType]);

  return (
    <FullHeightDivWithStyle>
      <Header editMode={docInfoSlice.poEditMode} />
      <Main>
        <POSdk
          res={res}
          shareID={shareID}
          su={su}
          mode={docInfoSlice.poEditMode}
          extFontsInfo={extFontsInfo}
        />
        <PopUpAppInstall />
      </Main>
      <FileMenuMain isShow={popupState.fileMenu.isShow} />
      {popupState.mobileBottomAD.isShow && <MobileBottomAD id={FIXED_AD_ID.IN_MOBILE_BOTTOM} />}
      <DialogSelector />
      <Toast />
      <PopupAd />
      <Confirm />
      <Notification />
      <ContextMenu />
      <LoadingSplash />
      {appData.extensionConnectMode && <WhaleHandler />}
      <NaverWorksProcessPopup />
    </FullHeightDivWithStyle>
  );
}

export default AppMain;
